// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context, params) {
    context.commit("set_loading");
    const { sortBy, descending, page, itemsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    return new Promise(resolve => {
      const { search, type, filters } = params;
      NewApiService.get("currency-rate", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: itemsPerPage,
        search: search,
        type: type,
        filters: filters
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve,reject) => {
      NewApiService.post("currency-rate", params.model)
        .then(({data}) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    });
  },
  update(context, params) {
    if(!params || !params.model || !params.model.id) return false;
    context.commit("set_loading");
    return new Promise((resolve,reject) => {
      NewApiService.put("currency-rate/"+params.model.id, params.model)
        .then(({data}) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    });
  },
  
  delete(context, params) {
    if(!params || !params.model || !params.model.id) return false
    context.commit("set_loading");
    return new Promise((resolve,reject) => {
      NewApiService.delete("currency-rate/"+params.model.id)
        .then(({data}) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    });
  },
};
